"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminalConsoleLogo = void 0;
var kb_error_1 = __importDefault(require("@kibibit/kb-error"));
var chalk_1 = __importDefault(require("chalk"));
var log = console.log;
var r = chalk_1.default.red;
var y = chalk_1.default.yellow;
var b = chalk_1.default.blue;
function terminalConsoleLogo(productName, applicationInfo) {
    if (!productName) {
        throw new kb_error_1.default('must pass a valid product name');
    }
    log(chalk_1.default.bgBlack.white(['\n',
        ' ⣶⣶⡆⠀⠀⠀⠀⠀⠀', r('⣴⣿⣶'), '⠀⢰⣶⣶⠀⠀⠀⠀⠀⠀⠀⠀', b('⣴⣿⣶'), '⠀⢰⣶⣶⠀⠀⠀⠀⠀⠀⠀⠀', y('⣴⣿⣶'), '⠀⠀⣶⣶⡄⠀⠀⠀ \n',
        ' ⣿⣿⡇⠀⠀⠀⠀⠀⠀', r('⠈⠛⠋'), '⠀⢸⣿⣿⠀⠀⠀⠀⠀⠀⠀⠀', b('⠈⠛⠋'), '⠀⢸⣿⣿⠀⠀⠀⠀⠀⠀⠀⠀', y('⠈⠛⠋'), '⠀⠀⣿⣿⡇⠀⠀⠀ \n',
        ' ⣿⣿⡇⠀⢀⣴⣿⡟⠁', r('⢸⣿⡇'), '⠀⢸⣿⣿⣾⣿⣿⣿⣷⣄⠀⠀', b('⢸⣿⡇'), '⠀⢸⣿⣿⣾⣿⣿⣿⣷⣄⠀⠀', y('⢸⣿⡇'), '⠀⣿⣿⣿⣿⣿⣿⣿ \n',
        ' ⣿⣿⡇⣠⣿⡿⠋⠀⠀', r('⢸⣿⡇'), '⠀⢸⣿⣿⠟⠁⠀⠉⢿⣿⣧⠀', b('⢸⣿⡇'), '⠀⢸⣿⣿⠟⠁⠀⠉⢿⣿⣧⠀', y('⢸⣿⡇'), '⠀⠉⣿⣿⡏⠉⠉⠉ \n',
        ' ⣿⣿⣿⣿⣿⣿⡄⠀⠀', r('⢸⣿⡇'), '⠀⢸⣿⣿⠀⠀⠀⠀⢸⣿⣿⠀', b('⢸⣿⡇'), '⠀⢸⣿⣿⠀⠀⠀⠀⢸⣿⣿⠀', y('⢸⣿⡇'), '⠀⠀⣿⣿⡇⠀⠀⠀ \n',
        ' ⣿⣿⡿⠋⠙⣿⣿⣄⠀', r('⢸⣿⡇'), '⠀⠀⢻⣿⣷⣤⣤⣴⣿⣿⠃⠀', b('⢸⣿⡇'), '⠀⠀⢻⣿⣷⣤⣤⣴⣿⣿⠃⠀', y('⢸⣿⡇'), '⠀⠀⠹⣿⣷⣦⣤⣤ \n',
        ' ⠛⠛⠃⠀⠀⠘⠛⠛⠂', r('⠘⠛⠃'), '⠀⠀⠀⠉⠛⠿⠿⠟⠋⠁⠀⠀', b('⠘⠛⠃'), '⠀⠀⠀⠉⠛⠿⠿⠟⠋⠁⠀⠀', y('⠘⠛⠃'), '⠀⠀⠀⠈⠛⠛⠛⠛ \n'
    ].join('')));
    var totalWidth = 50;
    var title = "  " + productName + "  ";
    var separator = '-----';
    log(getIndentation(totalWidth, title) + chalk_1.default.bgYellow.black(title));
    log(getIndentation(totalWidth, separator) + chalk_1.default.gray(separator));
    if (applicationInfo) {
        if (Array.isArray(applicationInfo)) {
            applicationInfo.forEach(function (line) {
                log(getIndentation(totalWidth, line) + chalk_1.default.gray(line));
            });
            log('\n');
        }
        else {
            log(getIndentation(totalWidth, applicationInfo) + chalk_1.default.gray(applicationInfo + "\n"));
        }
    }
}
exports.terminalConsoleLogo = terminalConsoleLogo;
function getIndentation(totalWidth, str) {
    var halfWidth = Math.floor(totalWidth / 2);
    var halfChars = Math.floor(str.length / 2);
    return ' '.repeat(halfWidth - halfChars);
}
//# sourceMappingURL=terminal.consologo.js.map